import FairyRaffleFactoryABI from "../abis/FairyRaffleFactory";
import FairyRaffleABI from "../abis/FairyRaffle";
import RaffleChefABI from "../abis/RaffleChef";
import { Narrow } from "abitype";

interface ContractConfig<TAbi> {
  address: `0x${string}`;
  abi: Narrow<TAbi>;
}

export function getFactoryConfig(): ContractConfig<
  typeof FairyRaffleFactoryABI
> {
  return {
    address: "0x92109F0d62075c80B8C8741931173c3A6aD9Cc5a",
    abi: FairyRaffleFactoryABI,
  };
}

export function getFairymintConfig(
  address: string
): ContractConfig<typeof FairyRaffleABI> {
  return {
    address: address as `0x${string}`,
    abi: FairyRaffleABI,
  };
}

export function getRaffleChefConfig(): ContractConfig<typeof RaffleChefABI> {
  return {
    address: "0x26881E8C452928A889654e4a8BaFBf205dD87812",
    abi: RaffleChefABI,
  };
}
